class TeamLargeSlider {
	constructor(el) {
		this.el = el
		this.slider = el.querySelector('.team-large-slider__slider')
		this.init()
	}
	init() {}
}

export const initTeamLargeSlider = () => {
	document.querySelectorAll('.team-large-slider').forEach(el => {
		new TeamLargeSlider(el)
	})
}

export default () => {}
